import { useState, useEffect, RefObject } from "react";

export const useActiveSection = (
  sectionRefs: { [key: string]: RefObject<HTMLElement> },
  threshold: number = 0.5
) => {
  const [activeSection, setActiveSection] = useState<string>("Главная");

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    Object.entries(sectionRefs).forEach(([sectionName, ref]) => {
      if (!ref.current) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActiveSection(sectionName);
          }
        },
        {
          threshold: threshold,
          rootMargin: "-20% 0px -20% 0px", // Настройка для более точного определения
        }
      );

      observer.observe(ref.current);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [sectionRefs, threshold]);

  return activeSection;
};
